'use client';

import { Skeleton } from '@/components/ui';
import { motion } from '@/libs';

export const SkeletonHighlightedRaffleDetails = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        staggerChildren: 0.15,
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
    },
  };

  return (
    <motion.div
      className="space-y-3 mt-1"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <motion.div
        variants={itemVariants}
        className="w-full p-4 bg-background-dark rounded-xl"
      >
        <Skeleton className="h-5 w-24 mb-3" />
        <div className="space-y-2 pt-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="w-full p-4 bg-background-dark rounded-xl"
      >
        <Skeleton className="h-5 w-40 mb-3" />
        <div className="flex flex-wrap gap-2 pt-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} className="h-10 w-16 rounded-md" />
          ))}
        </div>
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="w-full p-4 bg-background-dark rounded-xl"
      >
        <Skeleton className="h-5 w-32 mb-3" />
        <div className="space-y-3 pt-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex flex-col gap-1">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-32" />
              </div>
              <Skeleton className="h-6 w-20" />
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        variants={itemVariants}
        className="w-full p-4 bg-background-dark rounded-xl"
      >
        <Skeleton className="h-5 w-28 mb-3" />
        <div className="space-y-2 pt-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </motion.div>
    </motion.div>
  );
};
